import { gql } from "urql";
export const UnsubscribeFromLinkMutation = gql `
    mutation UnsubscribeFromLink($key1: String!, $key2: String!) {
        emailPreferences {
            unsubscribeFromLink(key1: $key1, key2: $key2) {
                success
            }
        }
    }
`;
export const UpdateEmailPreferenceMutation = gql `
    mutation UpdateEmailPreference($input: PublicUpdateEmailPreferencesInput!) {
        emailPreferences {
            updateEmailPreference(input: $input) {
                emailPreferenceId
                shouldSend
            }
        }
    }
`;
